import React from 'react';
import userManager from '@/API/userManager';
import { BellWrapper, BellIcon, NotSeenWrapper } from './Bell.styled';
import { getAmountOfNotSeenMessages } from '../../helpers/getAmountOfNotSeenMessages';
import { getBellColor } from './helpers/getBellColor';

const Bell = ({ setIsTicketsViewOpen, tickets }) => {
	const currentUserId = userManager.getUser().id;
	const amount = getAmountOfNotSeenMessages(tickets, currentUserId);
	const color = getBellColor(amount);
	
	return (
		<BellWrapper
			onClick={() => setIsTicketsViewOpen(() => true)}
			className='animation-scale'
			color={color}
		>
			<BellIcon
				color={color}
				name='bell'
			/>
			{!!amount && (
				<NotSeenWrapper>{amount}</NotSeenWrapper>
			)}
		</BellWrapper>
	);
};

export default Bell;
